import type { IntlShape } from "react-intl";
import type { PermissionProducts } from "../../enums/permissionProducts";
import type { PermissionProductTabOption } from "../types";

const getPermissionProductsTabOptions = (
  products: PermissionProducts[],
  formatMessage: IntlShape["formatMessage"],
): PermissionProductTabOption[] =>
  products
    .sort((a, b) => a.localeCompare(b))
    .map((productKey) => ({
      label: formatMessage({ id: `permissions.product.label.${productKey}` }),
      key: productKey,
    }));

export default getPermissionProductsTabOptions;
